import { fetchFamilyAttributes } from '@gn-audio/core/api/product-catalogue/fetch-family-attributes';
import { fetchGroupsAttributes } from '@gn-audio/core/api/product-catalogue/fetch-groups-attributes';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';

export const fetchFamilyOrGroupsAttributes = (familyId: number, groupsIds: number[] = []): Promise<IProductWithAttributes[]> | null => {
  return groupsIds.length > 0
    ? fetchGroupsAttributes(groupsIds)
    : familyId ? fetchFamilyAttributes(familyId) : null;
};
